import { takeLatest, put, call } from "redux-saga/effects"
import { AxiosResponse } from "axios"
import {
  fetchBankStatement,
  fetchBankStatementFailed,
  fetchBankStatementPayloadType,
  fetchBankStatementSuccess,
  fetchUploadHistory,
  fetchUploadHistoryFailed,
  fetchuploadHistoryPayloadType,
  fetchUploadHistorySuccess,
  fetchUploadlog,
  fetchUploadlogFailed,
  fetchuploadLogPayloadType,
  fetchUploadlogSuccess,
} from "../slices/uploadHistorySlice"
import {
  downloadBankStatementFileService,
  fetchUploadHistoryService,
  fetchUploadLogService,
} from "../services/uploadHistoryService"
import { uploadHistory, UploadLog } from "../models/uploadHistory.model"
import { showToast } from "../slices/toastSlice"

export function* fetchBookingHistorySaga(
  action: fetchuploadHistoryPayloadType,
) {
  try {
    const { data }: AxiosResponse = yield call(
      fetchUploadHistoryService,
      action,
    )

    yield put(
      fetchUploadHistorySuccess({
        uploadHistory: data?.data?.map((uploads: any) => ({
          ...new uploadHistory(uploads),
        })),
        totalRowCount: data.pagination.total || 0,
      }),
    )
  } catch (err) {
    yield put(fetchUploadHistoryFailed())
  }
}
export function* fetchUploadListSaga(action: fetchuploadLogPayloadType) {
  try {
    const { data }: AxiosResponse = yield call(fetchUploadLogService, action)

    yield put(
      fetchUploadlogSuccess({
        uploadLog: new UploadLog(data?.data),
      }),
    )
  } catch (err) {
    yield put(fetchUploadlogFailed())
  }
}

export function* downloadBankStatementFileSaga(
  action: fetchBankStatementPayloadType,
) {
  try {
    const { data } = yield call(downloadBankStatementFileService, action)
    const url = URL.createObjectURL(data)
    const a = document.createElement("a")
    a.href = url
    a.download = `${action.payload.name}`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    yield put(
      showToast({ toastType: "success", msg: "Successfully Downloaded" }),
    )
    yield put(fetchBankStatementSuccess())
  } catch (err: any) {
    yield put(fetchBankStatementFailed())
  }
}

export default function* bookingHistorySaga() {
  yield takeLatest(fetchUploadHistory, fetchBookingHistorySaga)
  yield takeLatest(fetchUploadlog, fetchUploadListSaga)
  yield takeLatest(fetchBankStatement, downloadBankStatementFileSaga)
}
